import { BaseElement } from "@/components";

import { html } from "lit";
import { customElement, property } from "lit/decorators.js";

@customElement("sb-header")
export class SbHeader extends BaseElement {
  get _containerElement(): HTMLLIElement | null {
    return this.querySelector(`div[part=${this.id ? this.id : "header"}]`);
  }

  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this;
  }
  @property({ type: String }) align: string = "center";
  @property({ type: String, attribute: "gap" }) gap: string = "8px";

  protected firstUpdated() {
    this.moveLightDomChildrenInto(this._containerElement!);
  }

  render() {
    return html` <div part=${this.id ? this.id : "header"}></div> `;
  }
}
